import { MemberData } from "./member.data.model";

export class MemberAssignmentRequest {
  readonly documentQueueId?: number;
  readonly workingDocumentId?: number;
  readonly tenantId?: string;
  readonly customerMemberId?: string;
  readonly startPage?: number;
  readonly endPage?: number;
  readonly createdUserId: number;
  readonly isIgnore: boolean = false;
  readonly action?: string;
  readonly committed: boolean = false;
  readonly pageType?: string;
  readonly memberData?: MemberData;

  constructor(init?: Partial<MemberAssignmentRequest>) {
    Object.assign(this, init);
  }
}
